import { Injectable } from '@angular/core';

export enum RejectionLink {
    Profile = 'https://app.toroinvestimentos.com.br/perfil/resgate',
    Help = 'https://ajuda.toroinvestimentos.com.br/hc/pt-br/articles/4416446708891'
}

export enum RejectionReasonCode {
    MG20 = 'MG20',
    MG19 = 'MG19'
}

export class RejectionReason {
    constructor(public reason: string, public link: string, public hasLink: boolean,) { }
}

@Injectable({
    providedIn: 'root',
  })
export class RejectionReasonService {

    public getRejectionReason(text: string) : RejectionReason {
        const link = this.getRejectionLink(text);
        const reason = this.getReason(text);
        return new RejectionReason(reason, link, !!link);
    }

    public getReason(text: string) : string {
        const pattern = /\[R\]/;
        if (text && text.search(pattern) > 0) {
            const indexStart = text.indexOf('[');
            return text.substring(0, indexStart);
        }
        return "";
    }

    public getRejectionLink(text: string) : string {
        const pattern = /\[LMG\d+\]/;
        if (text) {
            let match = text.match(pattern);
            if(match && match[0]) {
                let endMatch = match[0].length - 1;
                let startMatch = 2;
                let rejectionReasonCode = match[0].substring(startMatch, endMatch);
                return this.getRejectionLinkByCode(rejectionReasonCode);
            }
        }
        
        return "";
    }

    public getRejectionLinkByCode(code: string) : string {
        switch(code) {
            case RejectionReasonCode.MG19:
                return RejectionLink.Profile;
            case RejectionReasonCode.MG20:
                return RejectionLink.Help;
            default:
                return "";
        }
    }

}